import React from 'react';
import Icon from '../../../components/AppIcon';

const UserTypeSelector = ({ selectedType, onTypeSelect }) => {
  const userTypes = [
    {
      id: 'job_seeker',
      title: 'Job Seeker',
      description: 'Find your dream job with AI-powered matching',
      icon: 'User',
      benefits: ['AI-enhanced profile creation', 'Smart job recommendations', 'Resume optimization']
    },
    {
      id: 'hiring_manager',
      title: 'Hiring Manager',
      description: 'Streamline your recruitment process',
      icon: 'Users',
      benefits: ['Advanced candidate screening', 'AI-powered ranking', 'Pipeline management']
    },
    {
      id: 'company_admin',
      title: 'Company Admin',
      description: 'Manage your organization\'s hiring',
      icon: 'Building2',
      benefits: ['Company profile setup', 'Team management', 'Analytics dashboard']
    }
  ];

  return (
    <div className="space-y-4">
      <div className="text-center mb-6">
        <h3 className="text-lg font-semibold text-foreground mb-2">Choose Your Role</h3>
        <p className="text-sm text-muted-foreground">Select how you'll be using Recrutees</p>
      </div>
      <div className="grid gap-3">
        {userTypes?.map((type) => (
          <button
            key={type?.id}
            onClick={() => onTypeSelect(type?.id)}
            className={`p-4 rounded-lg border-2 text-left transition-all duration-200 hover:shadow-card ${
              selectedType === type?.id
                ? 'border-primary bg-primary/5 shadow-card'
                : 'border-border bg-card hover:border-primary/30'
            }`}
          >
            <div className="flex items-start space-x-3">
              <div className={`flex items-center justify-center w-10 h-10 rounded-lg ${
                selectedType === type?.id ? 'bg-primary text-white' : 'bg-muted text-muted-foreground'
              }`}>
                <Icon name={type?.icon} size={20} />
              </div>
              <div className="flex-1">
                <h4 className="font-medium text-foreground mb-1">{type?.title}</h4>
                <p className="text-sm text-muted-foreground mb-2">{type?.description}</p>
                <ul className="space-y-1">
                  {type?.benefits?.map((benefit, index) => (
                    <li key={index} className="flex items-center text-xs text-muted-foreground">
                      <Icon name="Check" size={12} className="mr-1.5 text-primary" />
                      {benefit}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default UserTypeSelector;